module.exports = __webpack_public_path__ + "static/media/embracon-azul.12f61a8b.webp";